import { Modal } from '@components/Modal';

export class ModalSaveBuild extends Modal {
    private $content: HTMLElement;
    private $contentActive: HTMLElement;
    private $form: HTMLFormElement;
    constructor() {
        super();
        // UI
        this.$content = this.querySelector('[data-modal-save-build-content]') as HTMLElement;
        this.$contentActive = this.querySelector(
            '[data-modal-save-build-content-active]'
        ) as HTMLElement;
        this.$form = this.querySelector('[data-modal-save-build-form]') as HTMLFormElement;

        this.init();
    }

    private init(): void {
        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();

            // TODO: Send form data to API
            console.log('submit');

            //Show success message
            this.showActiveContent();
        });
    }

    private showActiveContent(): void {
        this.$content.classList.add('-active');
        this.$contentActive.classList.remove('-active');
    }

    private hideActiveContent(): void {
        this.$content.classList.remove('-active');
        this.$contentActive.classList.add('-active');
    }

    onOpen(args: any): void {}

    onClose(): void {
        setTimeout(() => {
            this.hideActiveContent();
        }, 100);
    }
}
